<template>
  <layout-general v-if="modalVisible === 'delete-step'" @close="modalClose()">
    <h4 class="modal-title" slot="header">{{ $t('general.actions.delete') }} {{ $t('general.labels.step') }}</h4>
    <div slot="body">
      <div>
        <h4 class="help-block">{{ $t('modal.delete_step.are_you_sure') }}</h4>
      </div>
    </div>
    <div slot="footer">
      <button @click="stepRemove()" class="btn btn-danger">
         <span class="txt">{{ $t('modal.delete_step.yes') }}</span>
      </button>
      <button @click="modalClose()" class="btn">
         <span class="txt">{{ $t('general.actions.cancel') }}</span>
      </button>
    </div>
  </layout-general>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import LayoutGeneral from './layout/General.vue';

export default {
  components: {
    LayoutGeneral,
  },
  computed: mapGetters({
    modalVisible: 'modalVisible',
  }),
  methods: mapActions([
    'stepRemove',
    'modalClose',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** DeleteStep.vue?32867eec
 **/